var _rect, _rect2, _rect3, _rect4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _path, _path2, _path3, _path4, _rect5, _rect6, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleSilverCardBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 184,
    viewBox: "0 0 293 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 184,
    width: 184,
    height: 293,
    rx: 10,
    transform: "rotate(-90 0 184)",
    fill: "#1B0043"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 184,
    width: 184,
    height: 293,
    rx: 10,
    transform: "rotate(-90 0 184)",
    fill: "url(#paint0_radial_1604_4058)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1604_4058",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 293,
    height: 184
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 184,
    width: 184,
    height: 293,
    rx: 10,
    transform: "rotate(-90 0 184)",
    fill: "#070021"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1604_4058)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.18
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 184,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.52 -21.3213L292.321 0.480253L270.52 22.2818L248.718 0.480252L270.52 -21.3213Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.52 -21.3213L292.321 0.480253L270.52 22.2818L248.718 0.480252L270.52 -21.3213Z",
    fill: "url(#paint1_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.873 21.9282L249.072 0.126698L248.364 0.833805L270.166 22.6353L270.873 21.9282Z",
    fill: "black",
    mask: "url(#path-4-inside-1_1604_4058)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.52 24.3584L292.321 46.1599L270.52 67.9615L248.718 46.1599L270.52 24.3584Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.52 24.3584L292.321 46.1599L270.52 67.9615L248.718 46.1599L270.52 24.3584Z",
    fill: "url(#paint2_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.873 67.6079L249.072 45.8064L248.364 46.5135L270.166 68.315L270.873 67.6079Z",
    fill: "black",
    mask: "url(#path-6-inside-2_1604_4058)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-3_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.52 70.0371L292.321 91.8387L270.52 113.64L248.718 91.8387L270.52 70.0371Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.52 70.0371L292.321 91.8387L270.52 113.64L248.718 91.8387L270.52 70.0371Z",
    fill: "url(#paint3_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.873 113.287L249.072 91.4851L248.364 92.1922L270.166 113.994L270.873 113.287Z",
    fill: "black",
    mask: "url(#path-8-inside-3_1604_4058)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-4_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.52 115.718L292.321 137.519L270.52 159.321L248.718 137.519L270.52 115.718Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.52 115.718L292.321 137.519L270.52 159.321L248.718 137.519L270.52 115.718Z",
    fill: "url(#paint4_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.873 158.967L249.072 137.166L248.364 137.873L270.166 159.674L270.873 158.967Z",
    fill: "black",
    mask: "url(#path-10-inside-4_1604_4058)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-5_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.52 161.396L292.321 183.198L270.52 205L248.718 183.198L270.52 161.396Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.52 161.396L292.321 183.198L270.52 205L248.718 183.198L270.52 161.396Z",
    fill: "url(#paint5_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.873 204.646L249.072 182.844L248.364 183.552L270.166 205.353L270.873 204.646Z",
    fill: "black",
    mask: "url(#path-12-inside-5_1604_4058)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-6_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.84 -21.3213L246.641 0.480253L224.84 22.2818L203.038 0.480252L224.84 -21.3213Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.84 -21.3213L246.641 0.480253L224.84 22.2818L203.038 0.480252L224.84 -21.3213Z",
    fill: "url(#paint6_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.193 21.9282L203.392 0.126698L202.685 0.833805L224.486 22.6353L225.193 21.9282Z",
    fill: "black",
    mask: "url(#path-14-inside-6_1604_4058)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-7_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.68 1.51855L269.481 23.3201L247.68 45.1216L225.878 23.3201L247.68 1.51855Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.68 1.51855L269.481 23.3201L247.68 45.1216L225.878 23.3201L247.68 1.51855Z",
    fill: "url(#paint7_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.033 44.7681L226.232 22.9665L225.525 23.6736L247.326 45.4752L248.033 44.7681Z",
    fill: "black",
    mask: "url(#path-16-inside-7_1604_4058)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-8_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.68 47.1973L269.481 68.9988L247.68 90.8003L225.878 68.9988L247.68 47.1973Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.68 47.1973L269.481 68.9988L247.68 90.8003L225.878 68.9988L247.68 47.1973Z",
    fill: "url(#paint8_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.033 90.4468L226.232 68.6453L225.525 69.3524L247.326 91.1539L248.033 90.4468Z",
    fill: "black",
    mask: "url(#path-18-inside-8_1604_4058)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-9_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.68 92.8779L269.481 114.679L247.68 136.481L225.878 114.679L247.68 92.8779Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.68 92.8779L269.481 114.679L247.68 136.481L225.878 114.679L247.68 92.8779Z",
    fill: "url(#paint9_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.033 136.127L226.232 114.326L225.525 115.033L247.326 136.835L248.033 136.127Z",
    fill: "black",
    mask: "url(#path-20-inside-9_1604_4058)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-10_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.68 138.557L269.481 160.358L247.68 182.16L225.878 160.358L247.68 138.557Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.68 138.557L269.481 160.358L247.68 182.16L225.878 160.358L247.68 138.557Z",
    fill: "url(#paint10_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.033 181.806L226.232 160.005L225.525 160.712L247.326 182.513L248.033 181.806Z",
    fill: "black",
    mask: "url(#path-22-inside-10_1604_4058)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-11_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.355 1.51855L315.157 23.3201L293.355 45.1216L271.554 23.3201L293.355 1.51855Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.355 1.51855L315.157 23.3201L293.355 45.1216L271.554 23.3201L293.355 1.51855Z",
    fill: "url(#paint11_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.709 44.7681L271.907 22.9665L271.2 23.6736L293.002 45.4752L293.709 44.7681Z",
    fill: "black",
    mask: "url(#path-24-inside-11_1604_4058)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-12_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.355 47.1973L315.157 68.9988L293.355 90.8003L271.554 68.9988L293.355 47.1973Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.355 47.1973L315.157 68.9988L293.355 90.8003L271.554 68.9988L293.355 47.1973Z",
    fill: "url(#paint12_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.709 90.4468L271.907 68.6453L271.2 69.3524L293.002 91.1539L293.709 90.4468Z",
    fill: "black",
    mask: "url(#path-26-inside-12_1604_4058)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-13_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.355 92.8779L315.157 114.679L293.355 136.481L271.554 114.679L293.355 92.8779Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.355 92.8779L315.157 114.679L293.355 136.481L271.554 114.679L293.355 92.8779Z",
    fill: "url(#paint13_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.709 136.127L271.907 114.326L271.2 115.033L293.002 136.835L293.709 136.127Z",
    fill: "black",
    mask: "url(#path-28-inside-13_1604_4058)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-14_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.355 138.557L315.157 160.358L293.355 182.16L271.554 160.358L293.355 138.557Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.355 138.557L315.157 160.358L293.355 182.16L271.554 160.358L293.355 138.557Z",
    fill: "url(#paint14_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.709 181.806L271.907 160.005L271.2 160.712L293.002 182.513L293.709 181.806Z",
    fill: "black",
    mask: "url(#path-30-inside-14_1604_4058)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-15_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.84 24.3584L246.641 46.1599L224.84 67.9615L203.038 46.1599L224.84 24.3584Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.84 24.3584L246.641 46.1599L224.84 67.9615L203.038 46.1599L224.84 24.3584Z",
    fill: "url(#paint15_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.193 67.6079L203.392 45.8064L202.685 46.5135L224.486 68.315L225.193 67.6079Z",
    fill: "black",
    mask: "url(#path-32-inside-15_1604_4058)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-34-inside-16_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.84 70.0371L246.641 91.8387L224.84 113.64L203.038 91.8387L224.84 70.0371Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.84 70.0371L246.641 91.8387L224.84 113.64L203.038 91.8387L224.84 70.0371Z",
    fill: "url(#paint16_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.193 113.287L203.392 91.4851L202.685 92.1922L224.486 113.994L225.193 113.287Z",
    fill: "black",
    mask: "url(#path-34-inside-16_1604_4058)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-36-inside-17_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.84 115.718L246.641 137.519L224.84 159.321L203.038 137.519L224.84 115.718Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.84 115.718L246.641 137.519L224.84 159.321L203.038 137.519L224.84 115.718Z",
    fill: "url(#paint17_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.193 158.967L203.392 137.166L202.685 137.873L224.486 159.674L225.193 158.967Z",
    fill: "black",
    mask: "url(#path-36-inside-17_1604_4058)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-38-inside-18_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.84 161.396L246.641 183.198L224.84 205L203.038 183.198L224.84 161.396Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.84 161.396L246.641 183.198L224.84 205L203.038 183.198L224.84 161.396Z",
    fill: "url(#paint18_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.193 204.646L203.392 182.844L202.685 183.552L224.486 205.353L225.193 204.646Z",
    fill: "black",
    mask: "url(#path-38-inside-18_1604_4058)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-40-inside-19_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.16 -21.3213L200.962 0.480253L179.16 22.2818L157.359 0.480252L179.16 -21.3213Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.16 -21.3213L200.962 0.480253L179.16 22.2818L157.359 0.480252L179.16 -21.3213Z",
    fill: "url(#paint19_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.514 21.9282L157.712 0.126698L157.005 0.833805L178.807 22.6353L179.514 21.9282Z",
    fill: "black",
    mask: "url(#path-40-inside-19_1604_4058)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-20_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202 1.51855L223.802 23.3201L202 45.1216L180.198 23.3201L202 1.51855Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202 1.51855L223.802 23.3201L202 45.1216L180.198 23.3201L202 1.51855Z",
    fill: "url(#paint20_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.354 44.7681L180.552 22.9665L179.845 23.6736L201.646 45.4752L202.354 44.7681Z",
    fill: "black",
    mask: "url(#path-42-inside-20_1604_4058)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-44-inside-21_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202 47.1973L223.802 68.9988L202 90.8003L180.198 68.9988L202 47.1973Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202 47.1973L223.802 68.9988L202 90.8003L180.198 68.9988L202 47.1973Z",
    fill: "url(#paint21_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.354 90.4468L180.552 68.6453L179.845 69.3524L201.646 91.1539L202.354 90.4468Z",
    fill: "black",
    mask: "url(#path-44-inside-21_1604_4058)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-46-inside-22_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.32 47.1973L178.122 68.9988L156.32 90.8003L134.519 68.9988L156.32 47.1973Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.32 47.1973L178.122 68.9988L156.32 90.8003L134.519 68.9988L156.32 47.1973Z",
    fill: "url(#paint22_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.674 90.4468L134.872 68.6453L134.165 69.3524L155.967 91.1539L156.674 90.4468Z",
    fill: "black",
    mask: "url(#path-46-inside-22_1604_4058)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-48-inside-23_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.102 69.0928L154.903 90.8943L133.102 112.696L111.3 90.8943L133.102 69.0928Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.102 69.0928L154.903 90.8943L133.102 112.696L111.3 90.8943L133.102 69.0928Z",
    fill: "url(#paint23_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.455 112.342L111.654 90.5408L110.946 91.2479L132.748 113.049L133.455 112.342Z",
    fill: "black",
    mask: "url(#path-48-inside-23_1604_4058)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-50-inside-24_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202 92.8779L223.802 114.679L202 136.481L180.198 114.679L202 92.8779Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202 92.8779L223.802 114.679L202 136.481L180.198 114.679L202 92.8779Z",
    fill: "url(#paint24_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.354 136.127L180.552 114.326L179.845 115.033L201.646 136.835L202.354 136.127Z",
    fill: "black",
    mask: "url(#path-50-inside-24_1604_4058)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-52-inside-25_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.32 92.8779L178.122 114.679L156.32 136.481L134.519 114.679L156.32 92.8779Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.32 92.8779L178.122 114.679L156.32 136.481L134.519 114.679L156.32 92.8779Z",
    fill: "url(#paint25_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.674 136.127L134.872 114.326L134.165 115.033L155.967 136.835L156.674 136.127Z",
    fill: "black",
    mask: "url(#path-52-inside-25_1604_4058)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-54-inside-26_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.48 115.718L155.282 137.519L133.48 159.321L111.679 137.519L133.48 115.718Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.48 115.718L155.282 137.519L133.48 159.321L111.679 137.519L133.48 115.718Z",
    fill: "url(#paint26_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.834 158.967L112.032 137.166L111.325 137.873L133.127 159.674L133.834 158.967Z",
    fill: "black",
    mask: "url(#path-54-inside-26_1604_4058)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-56-inside-27_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202 138.557L223.802 160.358L202 182.16L180.198 160.358L202 138.557Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202 138.557L223.802 160.358L202 182.16L180.198 160.358L202 138.557Z",
    fill: "url(#paint27_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.354 181.806L180.552 160.005L179.845 160.712L201.646 182.513L202.354 181.806Z",
    fill: "black",
    mask: "url(#path-56-inside-27_1604_4058)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-58-inside-28_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.32 138.557L178.122 160.358L156.32 182.16L134.519 160.358L156.32 138.557Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.32 138.557L178.122 160.358L156.32 182.16L134.519 160.358L156.32 138.557Z",
    fill: "url(#paint28_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.674 181.806L134.872 160.005L134.165 160.712L155.967 182.513L156.674 181.806Z",
    fill: "black",
    mask: "url(#path-58-inside-28_1604_4058)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-60-inside-29_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.641 138.557L132.442 160.358L110.641 182.16L88.8391 160.358L110.641 138.557Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.641 138.557L132.442 160.358L110.641 182.16L88.8391 160.358L110.641 138.557Z",
    fill: "url(#paint29_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.994 181.806L89.1926 160.005L88.4855 160.712L110.287 182.513L110.994 181.806Z",
    fill: "black",
    mask: "url(#path-60-inside-29_1604_4058)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-62-inside-30_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.16 24.3584L200.962 46.1599L179.16 67.9615L157.359 46.1599L179.16 24.3584Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.16 24.3584L200.962 46.1599L179.16 67.9615L157.359 46.1599L179.16 24.3584Z",
    fill: "url(#paint30_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.514 67.6079L157.712 45.8064L157.005 46.5135L178.807 68.315L179.514 67.6079Z",
    fill: "black",
    mask: "url(#path-62-inside-30_1604_4058)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-64-inside-31_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.16 70.0371L200.962 91.8387L179.16 113.64L157.359 91.8387L179.16 70.0371Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.16 70.0371L200.962 91.8387L179.16 113.64L157.359 91.8387L179.16 70.0371Z",
    fill: "url(#paint31_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.514 113.287L157.712 91.4851L157.005 92.1922L178.807 113.994L179.514 113.287Z",
    fill: "black",
    mask: "url(#path-64-inside-31_1604_4058)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-66-inside-32_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.16 115.718L200.962 137.519L179.16 159.321L157.359 137.519L179.16 115.718Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.16 115.718L200.962 137.519L179.16 159.321L157.359 137.519L179.16 115.718Z",
    fill: "url(#paint32_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.514 158.967L157.712 137.166L157.005 137.873L178.807 159.674L179.514 158.967Z",
    fill: "black",
    mask: "url(#path-66-inside-32_1604_4058)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-33_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.16 161.396L200.962 183.198L179.16 205L157.359 183.198L179.16 161.396Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.16 161.396L200.962 183.198L179.16 205L157.359 183.198L179.16 161.396Z",
    fill: "url(#paint33_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.514 204.646L157.712 182.844L157.005 183.552L178.807 205.353L179.514 204.646Z",
    fill: "black",
    mask: "url(#path-68-inside-33_1604_4058)"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-70-inside-34_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.48 161.396L155.282 183.198L133.48 205L111.679 183.198L133.48 161.396Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.48 161.396L155.282 183.198L133.48 205L111.679 183.198L133.48 161.396Z",
    fill: "url(#paint34_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.834 204.646L112.032 182.844L111.325 183.552L133.127 205.353L133.834 204.646Z",
    fill: "black",
    mask: "url(#path-70-inside-34_1604_4058)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-72-inside-35_1604_4058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.8008 161.396L109.602 183.198L87.8008 205L65.9992 183.198L87.8008 161.396Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.8008 161.396L109.602 183.198L87.8008 205L65.9992 183.198L87.8008 161.396Z",
    fill: "url(#paint35_linear_1604_4058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1543 204.646L66.3528 182.844L65.6457 183.552L87.4472 205.353L88.1543 204.646Z",
    fill: "black",
    mask: "url(#path-72-inside-35_1604_4058)"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.827 95.9635C259.407 95.7935 259.107 95.4135 259.037 94.9635C258.987 94.7035 259.037 94.5235 259.437 93.8035C260.937 91.1035 261.707 88.0535 261.667 84.9635C261.707 81.9635 260.977 79.0335 259.537 76.4035C259.327 75.9635 259.137 75.5435 258.977 75.0935C259.037 74.7135 259.227 74.3635 259.537 74.1535C259.987 73.9135 260.537 73.9635 260.947 74.2435C261.227 74.6035 261.467 74.9635 261.667 75.3835C262.743 77.4444 263.475 79.6669 263.837 81.9635C264.067 83.7735 264.097 85.6135 263.927 87.4335C263.617 89.7735 262.927 92.0335 261.867 94.1435C261.227 95.4235 260.867 95.9635 260.487 95.9635H259.827Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.655 92.4333C255.535 93.0133 255.895 93.5933 256.465 93.7533V93.7033C257.295 93.9633 257.885 93.3533 258.725 91.4633C260.365 87.8233 260.565 83.6933 259.285 79.9033C258.865 78.6833 258.295 77.5233 257.575 76.4633C257.035 76.0433 256.305 76.1133 255.865 76.6033C255.495 77.1433 255.535 77.3433 256.165 78.6033C257.035 80.2133 257.565 81.9933 257.705 83.8233C257.935 86.3733 257.425 88.9333 256.245 91.2033C255.965 91.7633 255.655 92.3133 255.655 92.4333Z",
    fill: "#D8D8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.501 91.1765C252.627 91.3253 252.785 91.444 252.963 91.5239V91.4639C253.143 91.5539 253.343 91.5739 253.533 91.5539C254.073 91.4639 254.343 91.2139 254.883 90.1639C255.753 88.5739 256.193 86.7739 256.153 84.9639C256.164 83.1863 255.724 81.435 254.873 79.8739C254.333 78.7439 253.973 78.4339 253.333 78.4339C253.033 78.3939 252.753 78.5039 252.563 78.7239C252.033 79.2039 252.033 79.4639 252.683 80.7239C253.416 82.0529 253.801 83.546 253.801 85.0639C253.801 86.5817 253.416 88.0748 252.683 89.4039C252.233 90.2039 252.233 90.4639 252.233 90.6639C252.283 90.8526 252.375 91.0277 252.501 91.1765Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.036 88.6132C249.166 88.9632 249.426 89.2332 249.756 89.3932H249.766C250.366 89.5932 250.946 89.3632 251.456 88.5932C252.166 87.5136 252.544 86.25 252.544 84.9582C252.544 83.6664 252.166 82.4028 251.456 81.3232C250.956 80.5632 250.576 80.3332 250.036 80.4332C249.346 80.5532 248.926 81.1532 249.036 81.7832C249.163 82.057 249.31 82.3211 249.476 82.5732C249.966 83.2732 250.196 84.1132 250.126 84.9632C250.176 85.8032 249.936 86.6432 249.436 87.3232C249.036 87.9632 248.936 88.2632 249.036 88.6132Z",
    fill: "#D8D8D8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 293,
    height: 34,
    fill: "url(#paint36_linear_1604_4058)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 64,
    width: 220,
    height: 24,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.352 72.488L195.532 71.492H197.788L196.288 80H195.184L196.504 72.488H195.352ZM198.187 79.124C199.347 78.3 200.263 77.632 200.935 77.12C201.607 76.6 202.187 76.06 202.675 75.5C203.171 74.932 203.467 74.38 203.563 73.844C203.587 73.7 203.599 73.556 203.599 73.412C203.599 73.036 203.491 72.74 203.275 72.524C203.059 72.308 202.715 72.2 202.243 72.2C201.707 72.2 201.259 72.372 200.899 72.716C200.539 73.052 200.295 73.504 200.167 74.072H199.111C199.303 73.176 199.699 72.484 200.299 71.996C200.899 71.508 201.603 71.264 202.411 71.264C203.131 71.264 203.691 71.44 204.091 71.792C204.499 72.144 204.703 72.632 204.703 73.256C204.703 73.448 204.687 73.628 204.655 73.796C204.543 74.436 204.231 75.068 203.719 75.692C203.215 76.316 202.667 76.864 202.075 77.336C201.483 77.808 200.743 78.36 199.855 78.992H203.983L203.827 79.904H198.043L198.187 79.124ZM206.182 73.508C206.366 72.772 206.754 72.196 207.346 71.78C207.938 71.364 208.642 71.156 209.458 71.156C210.186 71.156 210.742 71.324 211.126 71.66C211.51 71.988 211.702 72.424 211.702 72.968C211.702 73.104 211.69 73.244 211.666 73.388C211.578 73.884 211.362 74.312 211.018 74.672C210.674 75.032 210.262 75.264 209.782 75.368V75.428C210.206 75.532 210.534 75.732 210.766 76.028C211.006 76.316 211.126 76.692 211.126 77.156C211.126 77.252 211.11 77.42 211.078 77.66C210.95 78.364 210.606 78.94 210.046 79.388C209.494 79.836 208.782 80.06 207.91 80.06C207.126 80.06 206.502 79.868 206.038 79.484C205.574 79.1 205.342 78.552 205.342 77.84C205.342 77.696 205.346 77.584 205.354 77.504H206.41C206.378 77.984 206.502 78.376 206.782 78.68C207.07 78.984 207.494 79.136 208.054 79.136C208.606 79.136 209.058 78.992 209.41 78.704C209.762 78.408 209.978 78.028 210.058 77.564C210.082 77.428 210.094 77.308 210.094 77.204C210.094 76.74 209.914 76.404 209.554 76.196C209.194 75.98 208.654 75.872 207.934 75.872H207.646L207.814 74.96H208.114C208.85 74.952 209.426 74.832 209.842 74.6C210.258 74.36 210.51 73.992 210.598 73.496C210.614 73.368 210.622 73.272 210.622 73.208C210.622 72.864 210.506 72.592 210.274 72.392C210.042 72.192 209.702 72.092 209.254 72.092C208.758 72.092 208.334 72.22 207.982 72.476C207.63 72.732 207.386 73.076 207.25 73.508H206.182Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.192 60.028C185.008 60.028 184.843 59.996 184.696 59.932C184.552 59.8653 184.439 59.7747 184.356 59.66C184.273 59.5427 184.231 59.408 184.228 59.256H184.616C184.629 59.3867 184.683 59.4973 184.776 59.588C184.872 59.676 185.011 59.72 185.192 59.72C185.365 59.72 185.501 59.6773 185.6 59.592C185.701 59.504 185.752 59.392 185.752 59.256C185.752 59.1493 185.723 59.0627 185.664 58.996C185.605 58.9293 185.532 58.8787 185.444 58.844C185.356 58.8093 185.237 58.772 185.088 58.732C184.904 58.684 184.756 58.636 184.644 58.588C184.535 58.54 184.44 58.4653 184.36 58.364C184.283 58.26 184.244 58.1213 184.244 57.948C184.244 57.796 184.283 57.6613 184.36 57.544C184.437 57.4267 184.545 57.336 184.684 57.272C184.825 57.208 184.987 57.176 185.168 57.176C185.429 57.176 185.643 57.2413 185.808 57.372C185.976 57.5027 186.071 57.676 186.092 57.892H185.692C185.679 57.7853 185.623 57.692 185.524 57.612C185.425 57.5293 185.295 57.488 185.132 57.488C184.98 57.488 184.856 57.528 184.76 57.608C184.664 57.6853 184.616 57.7947 184.616 57.936C184.616 58.0373 184.644 58.12 184.7 58.184C184.759 58.248 184.829 58.2973 184.912 58.332C184.997 58.364 185.116 58.4013 185.268 58.444C185.452 58.4947 185.6 58.5453 185.712 58.596C185.824 58.644 185.92 58.72 186 58.824C186.08 58.9253 186.12 59.064 186.12 59.24C186.12 59.376 186.084 59.504 186.012 59.624C185.94 59.744 185.833 59.8413 185.692 59.916C185.551 59.9907 185.384 60.028 185.192 60.028ZM188.656 58.82C188.656 58.8893 188.652 58.9627 188.644 59.04H186.892C186.905 59.256 186.978 59.4253 187.112 59.548C187.248 59.668 187.412 59.728 187.604 59.728C187.761 59.728 187.892 59.692 187.996 59.62C188.102 59.5453 188.177 59.4467 188.22 59.324H188.612C188.553 59.5347 188.436 59.7067 188.26 59.84C188.084 59.9707 187.865 60.036 187.604 60.036C187.396 60.036 187.209 59.9893 187.044 59.896C186.881 59.8027 186.753 59.6707 186.66 59.5C186.566 59.3267 186.52 59.1267 186.52 58.9C186.52 58.6733 186.565 58.4747 186.656 58.304C186.746 58.1333 186.873 58.0027 187.036 57.912C187.201 57.8187 187.39 57.772 187.604 57.772C187.812 57.772 187.996 57.8173 188.156 57.908C188.316 57.9987 188.438 58.124 188.524 58.284C188.612 58.4413 188.656 58.62 188.656 58.82ZM188.28 58.744C188.28 58.6053 188.249 58.4867 188.188 58.388C188.126 58.2867 188.042 58.2107 187.936 58.16C187.832 58.1067 187.716 58.08 187.588 58.08C187.404 58.08 187.246 58.1387 187.116 58.256C186.988 58.3733 186.914 58.536 186.896 58.744H188.28ZM189 58.9C189 58.6733 189.045 58.476 189.136 58.308C189.227 58.1373 189.352 58.0053 189.512 57.912C189.675 57.8187 189.86 57.772 190.068 57.772C190.337 57.772 190.559 57.8373 190.732 57.968C190.908 58.0987 191.024 58.28 191.08 58.512H190.688C190.651 58.3787 190.577 58.2733 190.468 58.196C190.361 58.1187 190.228 58.08 190.068 58.08C189.86 58.08 189.692 58.152 189.564 58.296C189.436 58.4373 189.372 58.6387 189.372 58.9C189.372 59.164 189.436 59.368 189.564 59.512C189.692 59.656 189.86 59.728 190.068 59.728C190.228 59.728 190.361 59.6907 190.468 59.616C190.575 59.5413 190.648 59.4347 190.688 59.296H191.08C191.021 59.52 190.904 59.7 190.728 59.836C190.552 59.9693 190.332 60.036 190.068 60.036C189.86 60.036 189.675 59.9893 189.512 59.896C189.352 59.8027 189.227 59.6707 189.136 59.5C189.045 59.3293 189 59.1293 189 58.9ZM193.51 57.808V60H193.146V59.676C193.076 59.788 192.979 59.876 192.854 59.94C192.731 60.0013 192.595 60.032 192.446 60.032C192.275 60.032 192.122 59.9973 191.986 59.928C191.85 59.856 191.742 59.7493 191.662 59.608C191.584 59.4667 191.546 59.2947 191.546 59.092V57.808H191.906V59.044C191.906 59.26 191.96 59.4267 192.07 59.544C192.179 59.6587 192.328 59.716 192.518 59.716C192.712 59.716 192.866 59.656 192.978 59.536C193.09 59.416 193.146 59.2413 193.146 59.012V57.808H193.51ZM194.488 58.164C194.552 58.0387 194.643 57.9413 194.76 57.872C194.88 57.8027 195.026 57.768 195.196 57.768V58.144H195.1C194.692 58.144 194.488 58.3653 194.488 58.808V60H194.124V57.808H194.488V58.164ZM195.805 57.452C195.735 57.452 195.677 57.428 195.629 57.38C195.581 57.332 195.557 57.2733 195.557 57.204C195.557 57.1347 195.581 57.076 195.629 57.028C195.677 56.98 195.735 56.956 195.805 56.956C195.871 56.956 195.927 56.98 195.973 57.028C196.021 57.076 196.045 57.1347 196.045 57.204C196.045 57.2733 196.021 57.332 195.973 57.38C195.927 57.428 195.871 57.452 195.805 57.452ZM195.981 57.808V60H195.617V57.808H195.981ZM197.045 58.108V59.4C197.045 59.5067 197.068 59.5827 197.113 59.628C197.158 59.6707 197.237 59.692 197.349 59.692H197.617V60H197.289C197.086 60 196.934 59.9533 196.833 59.86C196.732 59.7667 196.681 59.6133 196.681 59.4V58.108H196.397V57.808H196.681V57.256H197.045V57.808H197.617V58.108H197.045ZM199.946 57.808L198.626 61.032H198.25L198.682 59.976L197.798 57.808H198.202L198.89 59.584L199.57 57.808H199.946ZM201.242 58.604C201.242 58.332 201.304 58.088 201.426 57.872C201.549 57.6533 201.716 57.4827 201.926 57.36C202.14 57.2373 202.376 57.176 202.634 57.176C202.938 57.176 203.204 57.2493 203.43 57.396C203.657 57.5427 203.822 57.7507 203.926 58.02H203.49C203.413 57.852 203.301 57.7227 203.154 57.632C203.01 57.5413 202.837 57.496 202.634 57.496C202.44 57.496 202.265 57.5413 202.11 57.632C201.956 57.7227 201.834 57.852 201.746 58.02C201.658 58.1853 201.614 58.38 201.614 58.604C201.614 58.8253 201.658 59.02 201.746 59.188C201.834 59.3533 201.956 59.4813 202.11 59.572C202.265 59.6627 202.44 59.708 202.634 59.708C202.837 59.708 203.01 59.664 203.154 59.576C203.301 59.4853 203.413 59.356 203.49 59.188H203.926C203.822 59.4547 203.657 59.6613 203.43 59.808C203.204 59.952 202.938 60.024 202.634 60.024C202.376 60.024 202.14 59.964 201.926 59.844C201.716 59.7213 201.549 59.552 201.426 59.336C201.304 59.12 201.242 58.876 201.242 58.604ZM205.424 60.036C205.219 60.036 205.032 59.9893 204.864 59.896C204.699 59.8027 204.568 59.6707 204.472 59.5C204.379 59.3267 204.332 59.1267 204.332 58.9C204.332 58.676 204.38 58.4787 204.476 58.308C204.575 58.1347 204.708 58.0027 204.876 57.912C205.044 57.8187 205.232 57.772 205.44 57.772C205.648 57.772 205.836 57.8187 206.004 57.912C206.172 58.0027 206.304 58.1333 206.4 58.304C206.499 58.4747 206.548 58.6733 206.548 58.9C206.548 59.1267 206.497 59.3267 206.396 59.5C206.297 59.6707 206.163 59.8027 205.992 59.896C205.821 59.9893 205.632 60.036 205.424 60.036ZM205.424 59.716C205.555 59.716 205.677 59.6853 205.792 59.624C205.907 59.5627 205.999 59.4707 206.068 59.348C206.14 59.2253 206.176 59.076 206.176 58.9C206.176 58.724 206.141 58.5747 206.072 58.452C206.003 58.3293 205.912 58.2387 205.8 58.18C205.688 58.1187 205.567 58.088 205.436 58.088C205.303 58.088 205.18 58.1187 205.068 58.18C204.959 58.2387 204.871 58.3293 204.804 58.452C204.737 58.5747 204.704 58.724 204.704 58.9C204.704 59.0787 204.736 59.2293 204.8 59.352C204.867 59.4747 204.955 59.5667 205.064 59.628C205.173 59.6867 205.293 59.716 205.424 59.716ZM206.891 58.896C206.891 58.672 206.936 58.476 207.027 58.308C207.117 58.1373 207.241 58.0053 207.399 57.912C207.559 57.8187 207.737 57.772 207.935 57.772C208.105 57.772 208.264 57.812 208.411 57.892C208.557 57.9693 208.669 58.072 208.747 58.2V57.04H209.115V60H208.747V59.588C208.675 59.7187 208.568 59.8267 208.427 59.912C208.285 59.9947 208.12 60.036 207.931 60.036C207.736 60.036 207.559 59.988 207.399 59.892C207.241 59.796 207.117 59.6613 207.027 59.488C206.936 59.3147 206.891 59.1173 206.891 58.896ZM208.747 58.9C208.747 58.7347 208.713 58.5907 208.647 58.468C208.58 58.3453 208.489 58.252 208.375 58.188C208.263 58.1213 208.139 58.088 208.003 58.088C207.867 58.088 207.743 58.12 207.631 58.184C207.519 58.248 207.429 58.3413 207.363 58.464C207.296 58.5867 207.263 58.7307 207.263 58.896C207.263 59.064 207.296 59.2107 207.363 59.336C207.429 59.4587 207.519 59.5533 207.631 59.62C207.743 59.684 207.867 59.716 208.003 59.716C208.139 59.716 208.263 59.684 208.375 59.62C208.489 59.5533 208.58 59.4587 208.647 59.336C208.713 59.2107 208.747 59.0653 208.747 58.9ZM211.73 58.82C211.73 58.8893 211.726 58.9627 211.718 59.04H209.966C209.979 59.256 210.053 59.4253 210.186 59.548C210.322 59.668 210.486 59.728 210.678 59.728C210.835 59.728 210.966 59.692 211.07 59.62C211.177 59.5453 211.251 59.4467 211.294 59.324H211.686C211.627 59.5347 211.51 59.7067 211.334 59.84C211.158 59.9707 210.939 60.036 210.678 60.036C210.47 60.036 210.283 59.9893 210.118 59.896C209.955 59.8027 209.827 59.6707 209.734 59.5C209.641 59.3267 209.594 59.1267 209.594 58.9C209.594 58.6733 209.639 58.4747 209.73 58.304C209.821 58.1333 209.947 58.0027 210.11 57.912C210.275 57.8187 210.465 57.772 210.678 57.772C210.886 57.772 211.07 57.8173 211.23 57.908C211.39 57.9987 211.513 58.124 211.598 58.284C211.686 58.4413 211.73 58.62 211.73 58.82ZM211.354 58.744C211.354 58.6053 211.323 58.4867 211.262 58.388C211.201 58.2867 211.117 58.2107 211.01 58.16C210.906 58.1067 210.79 58.08 210.662 58.08C210.478 58.08 210.321 58.1387 210.19 58.256C210.062 58.3733 209.989 58.536 209.97 58.744H211.354Z",
    fill: "#D8D8D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.532 134.04V132.878H23.164V143H21.876V134.04H20.532ZM25.1984 141.978C26.3837 141.026 27.3124 140.247 27.9844 139.64C28.6564 139.024 29.221 138.385 29.6784 137.722C30.145 137.05 30.3784 136.392 30.3784 135.748C30.3784 135.141 30.229 134.665 29.9304 134.32C29.641 133.965 29.1697 133.788 28.5164 133.788C27.8817 133.788 27.387 133.989 27.0324 134.39C26.687 134.782 26.5004 135.309 26.4724 135.972H25.2404C25.2777 134.927 25.595 134.119 26.1924 133.55C26.7897 132.981 27.5597 132.696 28.5024 132.696C29.4637 132.696 30.2244 132.962 30.7844 133.494C31.3537 134.026 31.6384 134.759 31.6384 135.692C31.6384 136.467 31.405 137.223 30.9384 137.96C30.481 138.688 29.9584 139.332 29.3704 139.892C28.7824 140.443 28.031 141.087 27.1164 141.824H31.9324V142.888H25.1984V141.978ZM33.3771 135.426C33.4424 134.567 33.7738 133.895 34.3711 133.41C34.9684 132.925 35.7431 132.682 36.6951 132.682C37.3298 132.682 37.8758 132.799 38.3331 133.032C38.7998 133.256 39.1498 133.564 39.3831 133.956C39.6258 134.348 39.7471 134.791 39.7471 135.286C39.7471 135.865 39.5791 136.364 39.2431 136.784C38.9164 137.204 38.4871 137.475 37.9551 137.596V137.666C38.5618 137.815 39.0424 138.109 39.3971 138.548C39.7518 138.987 39.9291 139.561 39.9291 140.27C39.9291 140.802 39.8078 141.283 39.5651 141.712C39.3224 142.132 38.9584 142.463 38.4731 142.706C37.9878 142.949 37.4044 143.07 36.7231 143.07C35.7338 143.07 34.9218 142.813 34.2871 142.3C33.6524 141.777 33.2978 141.04 33.2231 140.088H34.4551C34.5204 140.648 34.7491 141.105 35.1411 141.46C35.5331 141.815 36.0558 141.992 36.7091 141.992C37.3624 141.992 37.8571 141.824 38.1931 141.488C38.5384 141.143 38.7111 140.699 38.7111 140.158C38.7111 139.458 38.4778 138.954 38.0111 138.646C37.5444 138.338 36.8398 138.184 35.8971 138.184H35.5751V137.12H35.9111C36.7698 137.111 37.4184 136.971 37.8571 136.7C38.2958 136.42 38.5151 135.991 38.5151 135.412C38.5151 134.917 38.3518 134.521 38.0251 134.222C37.7078 133.923 37.2504 133.774 36.6531 133.774C36.0744 133.774 35.6078 133.923 35.2531 134.222C34.8984 134.521 34.6884 134.922 34.6231 135.426H33.3771ZM41.3413 140.746V139.78L46.2553 132.976H47.7812V139.64H49.1813V140.746H47.7812V143H46.5213V140.746H41.3413ZM46.5773 134.306L42.8113 139.64H46.5773V134.306ZM64.3728 133.984H59.4588V137.176C59.6734 136.877 59.9908 136.635 60.4108 136.448C60.8308 136.252 61.2834 136.154 61.7688 136.154C62.5434 136.154 63.1734 136.317 63.6588 136.644C64.1441 136.961 64.4894 137.377 64.6948 137.89C64.9094 138.394 65.0168 138.931 65.0168 139.5C65.0168 140.172 64.8908 140.774 64.6388 141.306C64.3868 141.838 63.9994 142.258 63.4768 142.566C62.9634 142.874 62.3241 143.028 61.5588 143.028C60.5788 143.028 59.7854 142.776 59.1788 142.272C58.5721 141.768 58.2034 141.096 58.0728 140.256H59.3188C59.4401 140.788 59.6968 141.203 60.0888 141.502C60.4808 141.801 60.9754 141.95 61.5728 141.95C62.3101 141.95 62.8654 141.731 63.2388 141.292C63.6121 140.844 63.7988 140.256 63.7988 139.528C63.7988 138.8 63.6121 138.24 63.2388 137.848C62.8654 137.447 62.3148 137.246 61.5868 137.246C61.0921 137.246 60.6581 137.367 60.2848 137.61C59.9208 137.843 59.6548 138.165 59.4868 138.576H58.2828V132.864H64.3728V133.984ZM72.3518 135.286C72.1465 134.25 71.5071 133.732 70.4338 133.732C69.6031 133.732 68.9825 134.054 68.5718 134.698C68.1611 135.333 67.9605 136.383 67.9698 137.848C68.1845 137.363 68.5391 136.985 69.0338 136.714C69.5378 136.434 70.0978 136.294 70.7138 136.294C71.6751 136.294 72.4405 136.593 73.0098 137.19C73.5885 137.787 73.8778 138.613 73.8778 139.668C73.8778 140.303 73.7518 140.872 73.4998 141.376C73.2571 141.88 72.8838 142.281 72.3798 142.58C71.8851 142.879 71.2831 143.028 70.5738 143.028C69.6125 143.028 68.8611 142.813 68.3198 142.384C67.7785 141.955 67.4005 141.362 67.1858 140.606C66.9711 139.85 66.8638 138.917 66.8638 137.806C66.8638 134.381 68.0585 132.668 70.4478 132.668C71.3625 132.668 72.0811 132.915 72.6038 133.41C73.1265 133.905 73.4345 134.53 73.5278 135.286H72.3518ZM70.4478 137.372C70.0465 137.372 69.6685 137.456 69.3138 137.624C68.9591 137.783 68.6698 138.03 68.4458 138.366C68.2311 138.693 68.1238 139.094 68.1238 139.57C68.1238 140.279 68.3291 140.858 68.7398 141.306C69.1505 141.745 69.7385 141.964 70.5038 141.964C71.1571 141.964 71.6751 141.763 72.0578 141.362C72.4498 140.951 72.6458 140.401 72.6458 139.71C72.6458 138.982 72.4591 138.413 72.0858 138.002C71.7125 137.582 71.1665 137.372 70.4478 137.372ZM81.8265 133.872L77.9345 143H76.6465L80.5945 133.998H75.1905V132.906H81.8265V133.872ZM85.0871 137.736C84.5644 137.531 84.1631 137.232 83.8831 136.84C83.6031 136.448 83.4631 135.972 83.4631 135.412C83.4631 134.908 83.5891 134.455 83.8411 134.054C84.0931 133.643 84.4664 133.321 84.9611 133.088C85.4651 132.845 86.0718 132.724 86.7811 132.724C87.4904 132.724 88.0924 132.845 88.5871 133.088C89.0911 133.321 89.4691 133.643 89.7211 134.054C89.9824 134.455 90.1131 134.908 90.1131 135.412C90.1131 135.953 89.9684 136.429 89.6791 136.84C89.3898 137.241 88.9931 137.54 88.4891 137.736C89.0678 137.913 89.5251 138.226 89.8611 138.674C90.2064 139.113 90.3791 139.645 90.3791 140.27C90.3791 140.877 90.2298 141.409 89.9311 141.866C89.6324 142.314 89.2078 142.664 88.6571 142.916C88.1158 143.159 87.4904 143.28 86.7811 143.28C86.0718 143.28 85.4464 143.159 84.9051 142.916C84.3731 142.664 83.9578 142.314 83.6591 141.866C83.3604 141.409 83.2111 140.877 83.2111 140.27C83.2111 139.645 83.3791 139.108 83.7151 138.66C84.0511 138.212 84.5084 137.904 85.0871 137.736ZM88.8811 135.566C88.8811 134.997 88.6944 134.558 88.3211 134.25C87.9478 133.942 87.4344 133.788 86.7811 133.788C86.1371 133.788 85.6284 133.942 85.2551 134.25C84.8818 134.558 84.6951 135.001 84.6951 135.58C84.6951 136.103 84.8864 136.523 85.2691 136.84C85.6611 137.157 86.1651 137.316 86.7811 137.316C87.4064 137.316 87.9104 137.157 88.2931 136.84C88.6851 136.513 88.8811 136.089 88.8811 135.566ZM86.7811 138.296C86.0904 138.296 85.5258 138.459 85.0871 138.786C84.6484 139.103 84.4291 139.584 84.4291 140.228C84.4291 140.825 84.6391 141.306 85.0591 141.67C85.4884 142.034 86.0624 142.216 86.7811 142.216C87.4998 142.216 88.0691 142.034 88.4891 141.67C88.9091 141.306 89.1191 140.825 89.1191 140.228C89.1191 139.603 88.9044 139.127 88.4751 138.8C88.0458 138.464 87.4811 138.296 86.7811 138.296ZM101.174 140.284C101.267 140.816 101.482 141.227 101.818 141.516C102.163 141.805 102.625 141.95 103.204 141.95C103.979 141.95 104.548 141.647 104.912 141.04C105.285 140.433 105.463 139.411 105.444 137.974C105.248 138.394 104.921 138.725 104.464 138.968C104.007 139.201 103.498 139.318 102.938 139.318C102.313 139.318 101.753 139.192 101.258 138.94C100.773 138.679 100.39 138.301 100.11 137.806C99.83 137.311 99.69 136.714 99.69 136.014C99.69 135.015 99.9793 134.213 100.558 133.606C101.137 132.99 101.958 132.682 103.022 132.682C104.329 132.682 105.243 133.107 105.766 133.956C106.298 134.805 106.564 136.07 106.564 137.75C106.564 138.926 106.457 139.897 106.242 140.662C106.037 141.427 105.682 142.011 105.178 142.412C104.683 142.813 104.002 143.014 103.134 143.014C102.182 143.014 101.44 142.757 100.908 142.244C100.376 141.731 100.073 141.077 99.998 140.284H101.174ZM103.148 138.24C103.773 138.24 104.287 138.049 104.688 137.666C105.089 137.274 105.29 136.747 105.29 136.084C105.29 135.384 105.094 134.819 104.702 134.39C104.31 133.961 103.759 133.746 103.05 133.746C102.397 133.746 101.874 133.951 101.482 134.362C101.099 134.773 100.908 135.314 100.908 135.986C100.908 136.667 101.099 137.213 101.482 137.624C101.865 138.035 102.42 138.24 103.148 138.24ZM108.018 134.04V132.878H110.65V143H109.362V134.04H108.018ZM112.839 137.834C112.839 136.229 113.1 134.978 113.623 134.082C114.145 133.177 115.06 132.724 116.367 132.724C117.664 132.724 118.574 133.177 119.097 134.082C119.619 134.978 119.881 136.229 119.881 137.834C119.881 139.467 119.619 140.737 119.097 141.642C118.574 142.547 117.664 143 116.367 143C115.06 143 114.145 142.547 113.623 141.642C113.1 140.737 112.839 139.467 112.839 137.834ZM118.621 137.834C118.621 137.022 118.565 136.336 118.453 135.776C118.35 135.207 118.131 134.749 117.795 134.404C117.468 134.059 116.992 133.886 116.367 133.886C115.732 133.886 115.247 134.059 114.911 134.404C114.584 134.749 114.365 135.207 114.253 135.776C114.15 136.336 114.099 137.022 114.099 137.834C114.099 138.674 114.15 139.379 114.253 139.948C114.365 140.517 114.584 140.975 114.911 141.32C115.247 141.665 115.732 141.838 116.367 141.838C116.992 141.838 117.468 141.665 117.795 141.32C118.131 140.975 118.35 140.517 118.453 139.948C118.565 139.379 118.621 138.674 118.621 137.834ZM121.294 134.04V132.878H123.926V143H122.638V134.04H121.294ZM133.243 134.04V132.878H135.875V143H134.587V134.04H133.243ZM137.727 134.04V132.878H140.359V143H139.071V134.04H137.727ZM142.394 141.978C143.579 141.026 144.508 140.247 145.18 139.64C145.852 139.024 146.416 138.385 146.874 137.722C147.34 137.05 147.574 136.392 147.574 135.748C147.574 135.141 147.424 134.665 147.126 134.32C146.836 133.965 146.365 133.788 145.712 133.788C145.077 133.788 144.582 133.989 144.228 134.39C143.882 134.782 143.696 135.309 143.668 135.972H142.436C142.473 134.927 142.79 134.119 143.388 133.55C143.985 132.981 144.755 132.696 145.698 132.696C146.659 132.696 147.42 132.962 147.98 133.494C148.549 134.026 148.834 134.759 148.834 135.692C148.834 136.467 148.6 137.223 148.134 137.96C147.676 138.688 147.154 139.332 146.566 139.892C145.978 140.443 145.226 141.087 144.312 141.824H149.128V142.888H142.394V141.978ZM150.572 135.426C150.638 134.567 150.969 133.895 151.566 133.41C152.164 132.925 152.938 132.682 153.89 132.682C154.525 132.682 155.071 132.799 155.528 133.032C155.995 133.256 156.345 133.564 156.578 133.956C156.821 134.348 156.942 134.791 156.942 135.286C156.942 135.865 156.774 136.364 156.438 136.784C156.112 137.204 155.682 137.475 155.15 137.596V137.666C155.757 137.815 156.238 138.109 156.592 138.548C156.947 138.987 157.124 139.561 157.124 140.27C157.124 140.802 157.003 141.283 156.76 141.712C156.518 142.132 156.154 142.463 155.668 142.706C155.183 142.949 154.6 143.07 153.918 143.07C152.929 143.07 152.117 142.813 151.482 142.3C150.848 141.777 150.493 141.04 150.418 140.088H151.65C151.716 140.648 151.944 141.105 152.336 141.46C152.728 141.815 153.251 141.992 153.904 141.992C154.558 141.992 155.052 141.824 155.388 141.488C155.734 141.143 155.906 140.699 155.906 140.158C155.906 139.458 155.673 138.954 155.206 138.646C154.74 138.338 154.035 138.184 153.092 138.184H152.77V137.12H153.106C153.965 137.111 154.614 136.971 155.052 136.7C155.491 136.42 155.71 135.991 155.71 135.412C155.71 134.917 155.547 134.521 155.22 134.222C154.903 133.923 154.446 133.774 153.848 133.774C153.27 133.774 152.803 133.923 152.448 134.222C152.094 134.521 151.884 134.922 151.818 135.426H150.572Z",
    fill: "#D8D8D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.072 154.408L22.952 160H22.312L20.192 154.408H20.8L22.632 159.392L24.48 154.408H25.072ZM25.6574 157.808C25.6574 157.36 25.7454 156.968 25.9214 156.632C26.1028 156.291 26.3508 156.029 26.6654 155.848C26.9854 155.661 27.3454 155.568 27.7454 155.568C28.1614 155.568 28.5188 155.664 28.8174 155.856C29.1214 156.048 29.3401 156.293 29.4734 156.592V155.632H30.0334V160H29.4734V159.032C29.3348 159.331 29.1134 159.579 28.8094 159.776C28.5108 159.968 28.1534 160.064 27.7374 160.064C27.3428 160.064 26.9854 159.971 26.6654 159.784C26.3508 159.597 26.1028 159.333 25.9214 158.992C25.7454 158.651 25.6574 158.256 25.6574 157.808ZM29.4734 157.816C29.4734 157.464 29.4014 157.155 29.2574 156.888C29.1134 156.621 28.9161 156.416 28.6654 156.272C28.4201 156.128 28.1481 156.056 27.8494 156.056C27.5401 156.056 27.2628 156.125 27.0174 156.264C26.7721 156.403 26.5774 156.605 26.4334 156.872C26.2948 157.133 26.2254 157.445 26.2254 157.808C26.2254 158.165 26.2948 158.48 26.4334 158.752C26.5774 159.019 26.7721 159.224 27.0174 159.368C27.2628 159.507 27.5401 159.576 27.8494 159.576C28.1481 159.576 28.4201 159.504 28.6654 159.36C28.9161 159.216 29.1134 159.011 29.2574 158.744C29.4014 158.477 29.4734 158.168 29.4734 157.816ZM31.8719 154.08V160H31.3119V154.08H31.8719ZM33.42 154.808C33.308 154.808 33.212 154.768 33.132 154.688C33.052 154.608 33.012 154.509 33.012 154.392C33.012 154.275 33.052 154.179 33.132 154.104C33.212 154.024 33.308 153.984 33.42 153.984C33.532 153.984 33.628 154.024 33.708 154.104C33.788 154.179 33.828 154.275 33.828 154.392C33.828 154.509 33.788 154.608 33.708 154.688C33.628 154.768 33.532 154.808 33.42 154.808ZM33.7 155.632V160H33.14V155.632H33.7ZM34.7121 157.808C34.7121 157.36 34.8028 156.968 34.9841 156.632C35.1655 156.291 35.4135 156.029 35.7281 155.848C36.0481 155.661 36.4081 155.568 36.8081 155.568C37.1921 155.568 37.5388 155.661 37.8481 155.848C38.1575 156.035 38.3841 156.277 38.5281 156.576V154.08H39.0881V160H38.5281V159.024C38.3948 159.328 38.1761 159.579 37.8721 159.776C37.5681 159.968 37.2108 160.064 36.8001 160.064C36.4001 160.064 36.0401 159.971 35.7201 159.784C35.4055 159.597 35.1575 159.333 34.9761 158.992C34.8001 158.651 34.7121 158.256 34.7121 157.808ZM38.5281 157.816C38.5281 157.464 38.4561 157.155 38.3121 156.888C38.1681 156.621 37.9708 156.416 37.7201 156.272C37.4748 156.128 37.2028 156.056 36.9041 156.056C36.5948 156.056 36.3175 156.125 36.0721 156.264C35.8268 156.403 35.6321 156.605 35.4881 156.872C35.3495 157.133 35.2801 157.445 35.2801 157.808C35.2801 158.165 35.3495 158.48 35.4881 158.752C35.6321 159.019 35.8268 159.224 36.0721 159.368C36.3175 159.507 36.5948 159.576 36.9041 159.576C37.2028 159.576 37.4748 159.504 37.7201 159.36C37.9708 159.216 38.1681 159.011 38.3121 158.744C38.4561 158.477 38.5281 158.168 38.5281 157.816ZM45.8339 154.408V154.872H44.2819V160H43.7219V154.872H42.1619V154.408H45.8339ZM48.7981 155.552C49.1288 155.552 49.4248 155.621 49.6861 155.76C49.9528 155.899 50.1608 156.112 50.3101 156.4C50.4648 156.683 50.5421 157.029 50.5421 157.44V160H49.9901V157.504C49.9901 157.029 49.8701 156.667 49.6301 156.416C49.3955 156.165 49.0728 156.04 48.6621 156.04C48.2408 156.04 47.9048 156.173 47.6541 156.44C47.4035 156.707 47.2781 157.099 47.2781 157.616V160H46.7181V154.08H47.2781V156.376C47.4168 156.115 47.6195 155.912 47.8861 155.768C48.1581 155.624 48.4621 155.552 48.7981 155.552ZM52.3406 156.408C52.4633 156.136 52.65 155.925 52.9006 155.776C53.1566 155.627 53.4686 155.552 53.8366 155.552V156.136H53.6846C53.2793 156.136 52.954 156.245 52.7086 156.464C52.4633 156.683 52.3406 157.048 52.3406 157.56V160H51.7806V155.632H52.3406V156.408ZM58.4631 155.632V160H57.9031V159.232C57.7751 159.504 57.5777 159.712 57.3111 159.856C57.0444 160 56.7457 160.072 56.4151 160.072C55.8924 160.072 55.4657 159.912 55.1351 159.592C54.8044 159.267 54.6391 158.797 54.6391 158.184V155.632H55.1911V158.12C55.1911 158.595 55.3084 158.957 55.5431 159.208C55.7831 159.459 56.1084 159.584 56.5191 159.584C56.9404 159.584 57.2764 159.451 57.5271 159.184C57.7777 158.917 57.9031 158.525 57.9031 158.008V155.632H58.4631ZM59.8376 160.04C59.7202 160.04 59.6216 160 59.5416 159.92C59.4669 159.84 59.4296 159.741 59.4296 159.624C59.4296 159.507 59.4669 159.411 59.5416 159.336C59.6216 159.256 59.7202 159.216 59.8376 159.216C59.9496 159.216 60.0429 159.256 60.1176 159.336C60.1976 159.411 60.2376 159.507 60.2376 159.624C60.2376 159.741 60.1976 159.84 60.1176 159.92C60.0429 160 59.9496 160.04 59.8376 160.04ZM59.8376 156.56C59.7202 156.56 59.6216 156.52 59.5416 156.44C59.4669 156.36 59.4296 156.261 59.4296 156.144C59.4296 156.027 59.4669 155.931 59.5416 155.856C59.6216 155.776 59.7202 155.736 59.8376 155.736C59.9496 155.736 60.0429 155.776 60.1176 155.856C60.1976 155.931 60.2376 156.027 60.2376 156.144C60.2376 156.261 60.1976 156.36 60.1176 156.44C60.0429 156.52 59.9496 156.56 59.8376 156.56ZM63.2934 157.08C63.2934 156.163 63.4348 155.451 63.7174 154.944C64.0001 154.437 64.5068 154.184 65.2374 154.184C65.9681 154.184 66.4748 154.437 66.7574 154.944C67.0401 155.451 67.1814 156.163 67.1814 157.08C67.1814 158.013 67.0401 158.736 66.7574 159.248C66.4748 159.76 65.9681 160.016 65.2374 160.016C64.5014 160.016 63.9921 159.76 63.7094 159.248C63.4321 158.736 63.2934 158.013 63.2934 157.08ZM66.6294 157.08C66.6294 156.584 66.5948 156.165 66.5254 155.824C66.4561 155.483 66.3201 155.208 66.1174 155C65.9148 154.792 65.6214 154.688 65.2374 154.688C64.8534 154.688 64.5601 154.792 64.3574 155C64.1548 155.208 64.0188 155.483 63.9494 155.824C63.8801 156.165 63.8454 156.584 63.8454 157.08C63.8454 157.592 63.8801 158.021 63.9494 158.368C64.0188 158.709 64.1548 158.984 64.3574 159.192C64.5601 159.4 64.8534 159.504 65.2374 159.504C65.6214 159.504 65.9148 159.4 66.1174 159.192C66.3201 158.984 66.4561 158.709 66.5254 158.368C66.5948 158.021 66.6294 157.592 66.6294 157.08ZM69.3351 157.024C69.0045 156.917 68.7511 156.749 68.5751 156.52C68.4045 156.291 68.3191 156.013 68.3191 155.688C68.3191 155.4 68.3911 155.144 68.5351 154.92C68.6845 154.691 68.9005 154.512 69.1831 154.384C69.4658 154.251 69.8045 154.184 70.1991 154.184C70.5938 154.184 70.9325 154.251 71.2151 154.384C71.4978 154.512 71.7111 154.691 71.8551 154.92C72.0045 155.144 72.0791 155.4 72.0791 155.688C72.0791 156.008 71.9911 156.285 71.8151 156.52C71.6445 156.755 71.3938 156.923 71.0631 157.024C71.4258 157.115 71.7111 157.288 71.9191 157.544C72.1271 157.8 72.2311 158.112 72.2311 158.48C72.2311 158.821 72.1458 159.12 71.9751 159.376C71.8098 159.627 71.5725 159.821 71.2631 159.96C70.9591 160.099 70.6045 160.168 70.1991 160.168C69.7938 160.168 69.4365 160.099 69.1271 159.96C68.8231 159.821 68.5858 159.627 68.4151 159.376C68.2498 159.12 68.1671 158.821 68.1671 158.48C68.1671 158.112 68.2711 157.8 68.4791 157.544C68.6871 157.288 68.9725 157.115 69.3351 157.024ZM71.5351 155.752C71.5351 155.4 71.4151 155.128 71.1751 154.936C70.9351 154.744 70.6098 154.648 70.1991 154.648C69.7885 154.648 69.4631 154.744 69.2231 154.936C68.9831 155.123 68.8631 155.395 68.8631 155.752C68.8631 156.083 68.9858 156.347 69.2311 156.544C69.4765 156.741 69.7991 156.84 70.1991 156.84C70.5991 156.84 70.9218 156.741 71.1671 156.544C71.4125 156.347 71.5351 156.083 71.5351 155.752ZM70.1991 157.272C69.7618 157.272 69.4045 157.371 69.1271 157.568C68.8498 157.765 68.7111 158.064 68.7111 158.464C68.7111 158.848 68.8445 159.149 69.1111 159.368C69.3778 159.587 69.7405 159.696 70.1991 159.696C70.6525 159.696 71.0125 159.587 71.2791 159.368C71.5458 159.144 71.6791 158.843 71.6791 158.464C71.6791 158.069 71.5405 157.773 71.2631 157.576C70.9911 157.373 70.6365 157.272 70.1991 157.272ZM75.8233 152.48L73.6153 161.328H73.0633L75.2553 152.48H75.8233ZM76.6346 159.56C77.6159 158.824 78.3732 158.165 78.9066 157.584C79.4452 156.997 79.7146 156.424 79.7146 155.864C79.7146 155.496 79.6212 155.203 79.4346 154.984C79.2532 154.76 78.9546 154.648 78.5386 154.648C78.1332 154.648 77.8186 154.776 77.5946 155.032C77.3759 155.283 77.2532 155.619 77.2266 156.04H76.6826C76.7146 155.448 76.8959 154.989 77.2266 154.664C77.5626 154.333 77.9999 154.168 78.5386 154.168C79.0559 154.168 79.4746 154.315 79.7946 154.608C80.1146 154.896 80.2746 155.307 80.2746 155.84C80.2746 156.485 80.0052 157.112 79.4666 157.72C78.9332 158.323 78.2746 158.912 77.4906 159.488H80.4506V159.96H76.6346V159.56ZM82.4367 157.024C82.106 156.917 81.8527 156.749 81.6767 156.52C81.506 156.291 81.4207 156.013 81.4207 155.688C81.4207 155.4 81.4927 155.144 81.6367 154.92C81.786 154.691 82.002 154.512 82.2847 154.384C82.5674 154.251 82.906 154.184 83.3007 154.184C83.6954 154.184 84.034 154.251 84.3167 154.384C84.5994 154.512 84.8127 154.691 84.9567 154.92C85.106 155.144 85.1807 155.4 85.1807 155.688C85.1807 156.008 85.0927 156.285 84.9167 156.52C84.746 156.755 84.4954 156.923 84.1647 157.024C84.5274 157.115 84.8127 157.288 85.0207 157.544C85.2287 157.8 85.3327 158.112 85.3327 158.48C85.3327 158.821 85.2474 159.12 85.0767 159.376C84.9114 159.627 84.674 159.821 84.3647 159.96C84.0607 160.099 83.706 160.168 83.3007 160.168C82.8954 160.168 82.538 160.099 82.2287 159.96C81.9247 159.821 81.6874 159.627 81.5167 159.376C81.3514 159.12 81.2687 158.821 81.2687 158.48C81.2687 158.112 81.3727 157.8 81.5807 157.544C81.7887 157.288 82.074 157.115 82.4367 157.024ZM84.6367 155.752C84.6367 155.4 84.5167 155.128 84.2767 154.936C84.0367 154.744 83.7114 154.648 83.3007 154.648C82.89 154.648 82.5647 154.744 82.3247 154.936C82.0847 155.123 81.9647 155.395 81.9647 155.752C81.9647 156.083 82.0874 156.347 82.3327 156.544C82.578 156.741 82.9007 156.84 83.3007 156.84C83.7007 156.84 84.0234 156.741 84.2687 156.544C84.514 156.347 84.6367 156.083 84.6367 155.752ZM83.3007 157.272C82.8634 157.272 82.506 157.371 82.2287 157.568C81.9514 157.765 81.8127 158.064 81.8127 158.464C81.8127 158.848 81.946 159.149 82.2127 159.368C82.4794 159.587 82.842 159.696 83.3007 159.696C83.754 159.696 84.114 159.587 84.3807 159.368C84.6474 159.144 84.7807 158.843 84.7807 158.464C84.7807 158.069 84.642 157.773 84.3647 157.576C84.0927 157.373 83.738 157.272 83.3007 157.272Z",
    fill: "#D8D8D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1604_4058",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.00001 186.5) rotate(58.0745) scale(342.274 214.943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483113,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1604_4058",
    x1: 249.237,
    y1: 0.480253,
    x2: 292.84,
    y2: 0.480254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1604_4058",
    x1: 249.237,
    y1: 46.1599,
    x2: 292.84,
    y2: 46.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1604_4058",
    x1: 249.237,
    y1: 91.8387,
    x2: 292.84,
    y2: 91.8387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1604_4058",
    x1: 249.237,
    y1: 137.519,
    x2: 292.84,
    y2: 137.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1604_4058",
    x1: 249.237,
    y1: 183.198,
    x2: 292.84,
    y2: 183.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1604_4058",
    x1: 203.557,
    y1: 0.480253,
    x2: 247.16,
    y2: 0.480254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1604_4058",
    x1: 226.397,
    y1: 23.3201,
    x2: 270,
    y2: 23.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1604_4058",
    x1: 226.397,
    y1: 68.9988,
    x2: 270,
    y2: 68.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1604_4058",
    x1: 226.397,
    y1: 114.679,
    x2: 270,
    y2: 114.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1604_4058",
    x1: 226.397,
    y1: 160.358,
    x2: 270,
    y2: 160.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1604_4058",
    x1: 272.073,
    y1: 23.3201,
    x2: 315.676,
    y2: 23.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1604_4058",
    x1: 272.073,
    y1: 68.9988,
    x2: 315.676,
    y2: 68.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1604_4058",
    x1: 272.073,
    y1: 114.679,
    x2: 315.676,
    y2: 114.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1604_4058",
    x1: 272.073,
    y1: 160.358,
    x2: 315.676,
    y2: 160.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1604_4058",
    x1: 203.557,
    y1: 46.1599,
    x2: 247.16,
    y2: 46.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1604_4058",
    x1: 203.557,
    y1: 91.8387,
    x2: 247.16,
    y2: 91.8387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1604_4058",
    x1: 203.557,
    y1: 137.519,
    x2: 247.16,
    y2: 137.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1604_4058",
    x1: 203.557,
    y1: 183.198,
    x2: 247.16,
    y2: 183.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1604_4058",
    x1: 157.878,
    y1: 0.480253,
    x2: 201.481,
    y2: 0.480254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1604_4058",
    x1: 180.718,
    y1: 23.3201,
    x2: 224.321,
    y2: 23.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1604_4058",
    x1: 180.718,
    y1: 68.9988,
    x2: 224.321,
    y2: 68.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1604_4058",
    x1: 135.038,
    y1: 68.9988,
    x2: 178.641,
    y2: 68.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1604_4058",
    x1: 111.819,
    y1: 90.8943,
    x2: 155.422,
    y2: 90.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1604_4058",
    x1: 180.718,
    y1: 114.679,
    x2: 224.321,
    y2: 114.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1604_4058",
    x1: 135.038,
    y1: 114.679,
    x2: 178.641,
    y2: 114.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1604_4058",
    x1: 112.198,
    y1: 137.519,
    x2: 155.801,
    y2: 137.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1604_4058",
    x1: 180.718,
    y1: 160.358,
    x2: 224.321,
    y2: 160.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1604_4058",
    x1: 135.038,
    y1: 160.358,
    x2: 178.641,
    y2: 160.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1604_4058",
    x1: 89.3582,
    y1: 160.358,
    x2: 132.961,
    y2: 160.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1604_4058",
    x1: 157.878,
    y1: 46.1599,
    x2: 201.481,
    y2: 46.1599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1604_4058",
    x1: 157.878,
    y1: 91.8387,
    x2: 201.481,
    y2: 91.8387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1604_4058",
    x1: 157.878,
    y1: 137.519,
    x2: 201.481,
    y2: 137.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1604_4058",
    x1: 157.878,
    y1: 183.198,
    x2: 201.481,
    y2: 183.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1604_4058",
    x1: 112.198,
    y1: 183.198,
    x2: 155.801,
    y2: 183.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1604_4058",
    x1: 66.5183,
    y1: 183.198,
    x2: 110.121,
    y2: 183.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1604_4058",
    x1: 2.72877e-7,
    y1: 31,
    x2: 293,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleSilverCardBack);
export default __webpack_public_path__ + "static/media/purple-silver-card-back.40c8ea74df8ec9fdc227e2aaf2cba736.svg";
export { ForwardRef as ReactComponent };